// Editor-only: the published page never reads this — the server resolves the
// real phase, so a value chosen here cannot change what a visitor sees.

export const EVENT_ROOM_ELEMENT_TYPE = "EventVideoRoom";

export const ROOM_PREVIEW_PRE_EVENT = "pre-event";
export const ROOM_PREVIEW_EARLY_ACCESS = "early-access";
export const ROOM_PREVIEW_LIVE = "live";
export const ROOM_PREVIEW_ENDED = "ended";

export const ROOM_PREVIEW_STATES = [
  ROOM_PREVIEW_PRE_EVENT,
  ROOM_PREVIEW_EARLY_ACCESS,
  ROOM_PREVIEW_LIVE,
  ROOM_PREVIEW_ENDED,
];

export const ROOM_PREVIEW_STATE_LABELS = {
  [ROOM_PREVIEW_PRE_EVENT]: "Countdown",
  [ROOM_PREVIEW_EARLY_ACCESS]: "Just before",
  [ROOM_PREVIEW_LIVE]: "Live",
  [ROOM_PREVIEW_ENDED]: "Ended",
};

export function normalizeRoomPreviewState(state) {
  return ROOM_PREVIEW_STATES.includes(state) ? state : ROOM_PREVIEW_PRE_EVENT;
}

export function exampleTimingForRoomPreviewState(state, now) {
  switch (normalizeRoomPreviewState(state)) {
    case ROOM_PREVIEW_EARLY_ACCESS:
      return { startTime: now + 300, endTime: now + 3900, completedAt: 0, allowEarlyJoin: true, earlyJoinMinutes: 15 };
    case ROOM_PREVIEW_LIVE:
      return { startTime: now - 600, endTime: now + 3000, completedAt: 0 };
    case ROOM_PREVIEW_ENDED:
      return { startTime: now - 7200, endTime: now - 3600, completedAt: now - 3600 };
    default:
      return { startTime: now + 86400, endTime: now + 90000, completedAt: 0 };
  }
}
